import React, { useEffect } from "react";

function PageNotFound() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/snap.svg/0.3.0/snap.svg-min.js";
    script.async = true;
    document.body.appendChild(script);
  }, [])

  return (
    <div className="container">
      <div className="col-12 text-center">
        <img src="/404.svg" className="img-fluid" width={'720vh'} alt="" />
      </div>
    </div>
  )
}

export default PageNotFound